import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const CreateSupportCaseModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "CreateSupportCaseModalContainer" */
      './CreateSupportCaseModalContainer'
    ),
  loading: LoadingModal,
});
